export enum SystemType {
  ParkEval = 'PARK_EVAL',
  ParkAds = 'PARK_ADS'
}
